var map = {
	"./en-US/lang.ts": 29480,
	"./ja/lang.ts": 92778,
	"./zh-CN/lang.ts": 89482
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 40383;
module.exports = webpackAsyncContext;